"use strict";exports.capitaliseFirstLetter=t=>t.charAt(0).toUpperCase()+t.slice(1);
